import { requst } from '../config'

// 日历上数据
export const getFleetSummaryCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/fleetSummary/listByCalendar?
            startDate=${params.startDay}
            &endDate=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}`.replace(/\s*/g, '')
            break
        case 'week':
            url = `/fleetSummary/listByDateType?
            startWeek=${params.startWeek}
            &endWeek=${params.endWeek}
            &startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &year=${params.year}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'month':
            url = `/fleetSummary/listByDateType?
            dateType=${params.dateType}
            &locationId=${params.locationId}
            &projectId=${params.projectId} 
            &endDay=${params.endMonth}
            &year=${params.year}
            &startDay=${params.startMonth}`.replace(/\s*/g, '')
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询日期
export const getFleetSummaryByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/activity/diary/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 日 id
export const getFleetSummaryGetDayIdApi = params => {
    const url = `/fleetSummary/getInfo?produceDate=${params.produceDate}&projectId=${params.projectId}&dateType=${params.dateType}`
    return requst.get(url)
}

// 查询 月 id
export const getFleetSummaryGetIdApi = params => {
    const url = `/fleetSummary/getInfo?month=${params.month}&projectId=${params.projectId}&year=${params.year}&dateType=${params.dateType}`
    return requst.get(url)
}

// 查询 周 id
export const getFleetSummaryGetWeekIdApi = params => {
    const url = `/fleetSummary/getInfo?week=${params.week}&projectId=${params.projectId}&year=${params.year}&dateType=${params.dateType}`
    return requst.get(url)
}

// 获取数据
export const getFleetSummaryByIdApi = id => {
    const url = `/fleetSummary/get?id=${id}`
    return requst.get(url)
}

// 提交 船舶 总结
export const postFleetSummaryApi = commentData => {
    const url = `fleetSummary/save`
    return requst.post(url, { ...commentData })
}

// 提交 船舶 总结 周/月
export const postFleetSummaryWeekApi = commentData => {
    const url = `fleetSummary/saveWeek`
    return requst.post(url, { ...commentData })
}
